import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzSmd } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_SMD: Record<
  PageIdWoofzSmd,
  TPageConfig
> = {
  [PageIdWoofzSmd.DOG_AGE_SMD]: {
    id: PageIdWoofzSmd.DOG_AGE_SMD,
    hasHeader: true,
  },
  [PageIdWoofzSmd.DOG_SEX_SMD]: {
    id: PageIdWoofzSmd.DOG_SEX_SMD,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.DOG_BREED_SMD]: {
    id: PageIdWoofzSmd.DOG_BREED_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.URGE_SMD]: {
    id: PageIdWoofzSmd.URGE_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.GOALS_SMD]: {
    id: PageIdWoofzSmd.GOALS_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.URGE_1_SMD]: {
    id: PageIdWoofzSmd.URGE_1_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.AGRESSIVE_BEHAVIOR_SMD]: {
    id: PageIdWoofzSmd.AGRESSIVE_BEHAVIOR_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.TRIGGERS_SMD]: {
    id: PageIdWoofzSmd.TRIGGERS_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.URGE_2_SMD]: {
    id: PageIdWoofzSmd.URGE_2_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.BEHAVIOR_ISSUES_SMD]: {
    id: PageIdWoofzSmd.BEHAVIOR_ISSUES_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.DOG_LISTEN_SMD]: {
    id: PageIdWoofzSmd.DOG_LISTEN_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.COMMANDS_SMD]: {
    id: PageIdWoofzSmd.COMMANDS_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.EAT_OFF_THE_GROUND_SMD]: {
    id: PageIdWoofzSmd.EAT_OFF_THE_GROUND_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.DOG_ACT_SMD]: {
    id: PageIdWoofzSmd.DOG_ACT_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.DOG_OFF_AT_HOME_SMD]: {
    id: PageIdWoofzSmd.DOG_OFF_AT_HOME_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.PREPARE_SCREEN_SMD]: {
    id: PageIdWoofzSmd.PREPARE_SCREEN_SMD,
    hasHeader: true,
  },
  [PageIdWoofzSmd.DOG_PROFILE_SMD]: {
    id: PageIdWoofzSmd.DOG_PROFILE_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.HEAR_ABOUT_WOOFZ_SMD]: {
    id: PageIdWoofzSmd.HEAR_ABOUT_WOOFZ_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.MANNERS_TO_BUILD_SMD]: {
    id: PageIdWoofzSmd.MANNERS_TO_BUILD_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.FEEL_BETTER_SMD]: {
    id: PageIdWoofzSmd.FEEL_BETTER_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmd.PREPARE_FLOW_SMD]: {
    id: PageIdWoofzSmd.PREPARE_FLOW_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.EMAIL_SMD]: {
    id: PageIdWoofzSmd.EMAIL_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.NEWSLETTER_URGE_SMD]: {
    id: PageIdWoofzSmd.NEWSLETTER_URGE_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.SCRATCH_SCREEN_SMD]: {
    id: PageIdWoofzSmd.SCRATCH_SCREEN_SMD,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmd.SUBSCRIPTIONS_SMD]: {
    id: PageIdWoofzSmd.SUBSCRIPTIONS_SMD,
  },
  [PageIdWoofzSmd.CHAT_UPSELL_SMD]: {
    id: PageIdWoofzSmd.CHAT_UPSELL_SMD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmd.UPSELL_SMD]: {
    id: PageIdWoofzSmd.UPSELL_SMD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmd.UPSELL_FEEDING_GUIDE_SMD]: {
    id: PageIdWoofzSmd.UPSELL_FEEDING_GUIDE_SMD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmd.UPSELL_EMOTIONAL_SUPPORT_SMD]: {
    id: PageIdWoofzSmd.UPSELL_EMOTIONAL_SUPPORT_SMD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmd.DOWNLOAD_SMD]: {
    id: PageIdWoofzSmd.DOWNLOAD_SMD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmd.ACCOUNT_SMD]: {
    id: PageIdWoofzSmd.ACCOUNT_SMD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
